if (!customElements.get('featured-tiles')) {
  customElements.define(
    'featured-tiles',
    class FeaturedTiles extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.featured-tiles__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          controls: '.swiper-controls',
        };

        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.mobileItems = parseInt(this.dataset.mobileItems || 2);

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        this.init();
      }

      init() {
        this.initSlider();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

        this.sliderOptions = {
          slidesPerView: this.mobileItems,
          spaceBetween: columnGap.mobile || columnGap.tablet,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: false,

          // IMPORTANT: if slides fit, Swiper will lock navigation
          watchOverflow: true,

          // IMPORTANT: prevents "loop swiping" even when fits perfectly
          loop: false,

          breakpoints: {
            768: {
              slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
              spaceBetween: columnGap.tablet,
            },
            1024: {
              slidesPerView: this.items > 4 ? 4 : parseInt(this.items),
              spaceBetween: columnGap.tabletLarge,
            },
            1280: {
              // slidesPerView: parseInt(this.items),
              // spaceBetween: columnGap.desktop,

              // Force 6 items on desktop
                slidesPerView: 6,
                spaceBetween: columnGap.desktop,
            },
          },

          threshold: 2,
          on: {
            init: () => {
              this.updateControlsVisibility();
              this.calcNavButtonsPosition();
            },
            resize: () => {
              this.updateControlsVisibility();
              this.calcNavButtonsPosition();
            },
          },
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();

        // Safety: also recalc after images load
        window.setTimeout(() => this.updateControlsVisibility(), 50);
        window.setTimeout(() => this.updateControlsVisibility(), 250);
      }

      updateControlsVisibility() {
        const controls = this.section?.querySelector(this.selectors.controls);
        const nextBtn = this.section?.querySelector(this.selectors.nextEl);
        const prevBtn = this.section?.querySelector(this.selectors.prevEl);

        if (!controls || !nextBtn || !prevBtn) return;

        const nextLocked = nextBtn.classList.contains('swiper-button-lock');
        const prevLocked = prevBtn.classList.contains('swiper-button-lock');

        // If both locked, there's nothing to slide => hide the whole control group
        if (nextLocked && prevLocked) {
          controls.style.display = 'none';
        } else {
          controls.style.display = '';
        }
      }

      calcNavButtonsPosition() {
        const firstMedia = this.querySelector('.featured-tile__media');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty(
            '--swiper-navigation-top-offset',
            parseInt(firstMedia.clientHeight) / 2 + 'px'
          );
        }
      }
    }
  );
}